// @owners { team: patients }
import { type User } from '~shared/types';

// flowlint-next-line deprecated-utility:off
export type NewUserPayload = Omit<User, 'id'>;

export const UI_ONBOARDING_UPDATE_USER = 'UI_ONBOARDING_UPDATE_USER';
export type ActionUiOnboardingUpdateUser = {
  type: typeof UI_ONBOARDING_UPDATE_USER;
  payload: NewUserPayload;
};
export function updateUser(payload: NewUserPayload): ActionUiOnboardingUpdateUser {
  return {
    type: UI_ONBOARDING_UPDATE_USER,
    payload,
  };
}

export const UI_ONBOARDING_SET_ZIP = 'UI_ONBOARDING_SET_ZIP';
export type ActionUiOnboardingSetZip = {
  type: typeof UI_ONBOARDING_SET_ZIP;
  payload: string;
};
export function setZip(zip: string): ActionUiOnboardingSetZip {
  return {
    type: UI_ONBOARDING_SET_ZIP,
    payload: zip,
  };
}

export const UI_ONBOARDING_ENTER = 'UI_ONBOARDING_ENTER';
export type ActionUiOnboardingEnter = {
  type: typeof UI_ONBOARDING_ENTER;
};
export function enterOnboarding(): ActionUiOnboardingEnter {
  return {
    type: UI_ONBOARDING_ENTER,
  };
}

export const UI_ONBOARDING_EXIT = 'UI_ONBOARDING_EXIT';
export type ActionUiOnboardingExit = {
  type: typeof UI_ONBOARDING_EXIT;
};
export function exitOnboarding(): ActionUiOnboardingExit {
  return {
    type: UI_ONBOARDING_EXIT,
  };
}

export const SET_FERT_DELVERY_SIGNUP = 'SET_FERT_DELVERY_SIGNUP';
export type ActionSetFertDeliverySignup = {
  type: typeof SET_FERT_DELVERY_SIGNUP;
  payload: boolean;
};
export function setFertDeliverySignup(value: boolean) {
  return {
    type: SET_FERT_DELVERY_SIGNUP,
    payload: value,
  };
}

export const CLEAR_VALIDATING_USERS_ERROR = 'CLEAR_VALIDATING_USERS_ERROR';
type ActionClearValidatingUsersError = {
  type: typeof CLEAR_VALIDATING_USERS_ERROR;
};

export function clearValidatingUsersError(): ActionClearValidatingUsersError {
  return {
    type: CLEAR_VALIDATING_USERS_ERROR,
  };
}
